import * as Yup from 'yup';

export const loginSchema = Yup.object({
    username: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string().required('Password is required'),
});

export const signupSchema = Yup.object({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    mobile: Yup.string().required('Mobile Number is required'),
    username: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string().min(6, 'Minimum 6 characters').required('Password is required'),
});

export const forgotSchema = Yup.object({
    email: Yup.string().email('Invalid email').required('Email is required'),
});
